import { MenuItemProps, ResolvedBasicMenuItem, ResolvedSubMenuItem } from '@wix/thunderbolt-becky-types'

export const resolveMenuItemsRecursively = (
	item: ResolvedBasicMenuItem | ResolvedSubMenuItem,
	isMobileView: boolean,
	withId: boolean,
	shouldResolveLinksInPlace: boolean
): MenuItemProps => {
	const { id: itemId, label, items: subItems, link: itemLink, displayCount } = item
	// @ts-expect-error remove after adding this type to editor-elements-definition lib
	const { shouldSupportLegacySubmenuDesign } = item
	const id = withId ? { id: itemId } : {}
	// @ts-ignore
	const link = (shouldResolveLinksInPlace ? itemLink : itemLink?.resolvedLink) ?? {}
	const slot = isResolvedBasicMenuItem(item) ? { slot: item.slot } : {}

	const items = subItems
		? subItems
				.filter((subItem) => shouldShowItem(subItem, isMobileView))
				.map((subItem) => resolveMenuItemsRecursively(subItem, isMobileView, withId, shouldResolveLinksInPlace))
		: []

	const filteredItems = items.length > 0 ? { items } : {}

	return {
		label,
		link,
		// @ts-ignore TODO: remove after adding this type to editor-elements-definition lib
		...(displayCount ? { displayCount } : {}),
		...filteredItems,
		...slot,
		...id,
		...(shouldSupportLegacySubmenuDesign ? { shouldSupportLegacySubmenuDesign } : {}),
	}
}

const isResolvedBasicMenuItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem): item is ResolvedBasicMenuItem =>
	'slot' in item

const shouldShowItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem, isMobileView: boolean) => {
	return isMobileView ? item.isVisibleMobile : item.isVisible
}
